import { View, Text } from 'react-native';
import { BrandSwitch } from './BrandSwitch';
import { Button } from './Button';
import {
  LIFE_EVENT_TAX_TREATMENT_LABELS,
  type GoalInflowTaxTreatment,
} from '../lib/life-events';

const TAX_TREATMENTS: GoalInflowTaxTreatment[] = [
  'ordinary_income',
  'short_term_capital_gain',
  'long_term_capital_gain',
];

interface LifeEventTaxFieldsProps {
  isTaxable: boolean;
  taxTreatment: GoalInflowTaxTreatment;
  onTaxableChange: (value: boolean) => void;
  onTaxTreatmentChange: (value: GoalInflowTaxTreatment) => void;
}

export function LifeEventTaxFields({
  isTaxable,
  taxTreatment,
  onTaxableChange,
  onTaxTreatmentChange,
}: LifeEventTaxFieldsProps) {
  return (
    <View className="mb-3 rounded-xl border border-gray-100 dark:border-gray-700 bg-gray-50 dark:bg-gray-800/50 p-3">
      <View className="flex-row items-center justify-between gap-3">
        <Text className="text-sm font-medium text-gray-700 dark:text-gray-300">
          Taxable
        </Text>
        <BrandSwitch
          value={isTaxable}
          onValueChange={onTaxableChange}
          accessibilityLabel="Mark life event as taxable"
        />
      </View>

      {isTaxable && (
        <View className="flex-row flex-wrap gap-2 mt-3">
          {TAX_TREATMENTS.map((treatment) => (
            <Button
              key={treatment}
              size="sm"
              variant={taxTreatment === treatment ? 'primary' : 'secondary'}
              onPress={() => onTaxTreatmentChange(treatment)}
            >
              {LIFE_EVENT_TAX_TREATMENT_LABELS[treatment]}
            </Button>
          ))}
        </View>
      )}
    </View>
  );
}
